/* eslint-disable jsx-a11y/aria-role */
import { Amplitude, Events } from '@iwoca/frontend-tracking-library';
import { Button, Icon, Input } from '@iwoca/orion';
import clsx from 'clsx';
import { useLocale } from 'hooks/useLocale';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import { PersonalDetails } from '../PersonalDetails/PersonalDetails';
import { TSignupFormData } from '../SignupForm/SignupForm';

import { GuarantorRoles } from './GuarantorRoles/GuarantorRoles';
import styles from './Guarantors.module.css';

/** TODO: Figure out how we should be assigning array of roles to each Personal Details. */
export const Guarantors = () => {
  const { locale } = useLocale();
  const {
    register,
    formState: { errors },
    setValue,
    watch,
  } = useFormContext<TSignupFormData>();

  const watchPrivacyPolicy = watch('applicant.privacyPolicyAgreement');

  const { fields, append, remove } = useFieldArray({
    name: 'guarantor',
  });

  const setPrivacyPolicy = (index: number) => {
    setValue(`guarantor.${index}.privacyPolicyAgreement`, watchPrivacyPolicy);
  };

  return (
    <div
      className={clsx(
        styles.container,
        fields.length === 0 && styles.buttonContainer,
      )}
    >
      {fields.map((field, index) => {
        setPrivacyPolicy(index);

        return (
          <section key={field.id} className={styles.fieldContainer}>
            {index > 0 && <hr className={styles.seperator} />}
            <div className={styles.guarantorHeading}>
              <h2>Contact {index + 1}</h2>
              <Button
                type="button"
                data-testid="remove-guarantor-button"
                variant="tertiary"
                className={clsx(styles.guarantorButton, styles.removeGuarantor)}
                onClick={() => {
                  remove(index);
                  Amplitude.track(
                    Events.introducerPortal.introducerPortalEventCreator({
                      event: AMPLITUDE_EVENTS.extraDetailsRemoved,
                      locale,
                      payload: {
                        'Page name': document.title,
                        URL: window.location.pathname,
                        'Details added': 'New contact',
                        'CTA text': 'Remove',
                      },
                    }),
                  );
                }}
              >
                <Icon icon="trashFilled" />
              </Button>
            </div>
            <GuarantorRoles index={index} />
            <div className={styles.nameContainer}>
              <Input
                {...register(`guarantor.${index}.firstName`)}
                type="text"
                label="First name"
                wrapperClassName={styles.nameField}
                error={errors?.guarantor?.[index]?.firstName?.message}
              />
              <Input
                {...register(`guarantor.${index}.lastName`)}
                type="text"
                label="Last name"
                wrapperClassName={styles.nameField}
                error={errors?.guarantor?.[index]?.lastName?.message}
              />
            </div>
            <PersonalDetails role="guarantor" index={index} />
          </section>
        );
      })}
      <Button
        type="button"
        variant="tertiary"
        className={clsx(styles.guarantorButton, styles.addGuarantor)}
        onClick={() => {
          append({});
          Amplitude.track(
            Events.introducerPortal.introducerPortalEventCreator({
              event: AMPLITUDE_EVENTS.extraDetailsAdded,
              locale,
              payload: {
                'Page name': document.title,
                URL: window.location.pathname,
                'Details added': 'New contact',
                'CTA text': 'Add new contact',
              },
            }),
          );
        }}
      >
        <Icon icon="plus" fontSize="1.3rem" />
        Add new contact
      </Button>
    </div>
  );
};
